(function(angular) {
    'use strict';

    angular.module('onvio.documents')
        .constant('treeNavRouteModel', {
            'Project' : 'project',
            'Folder' : 'folder',
            'Client': 'client',
            'My': 'my',
            'Firm': 'firm',
        });

})((window as any).angular);
